import React, { useEffect } from "react";
import CaseList from "../components/CaseModule/CaseList";
import { Container, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const EditCaseListPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  }, [navigate]);

  const today = new Date();
today.setDate(today.getDate() - 1); // Subtract 1 day safely

const dd = String(today.getDate()).padStart(2, "0");
const mm = String(today.getMonth() + 1).padStart(2, "0");
const yyyy = today.getFullYear();

const date = `${yyyy}/${mm}/${dd}`;
const casestatus = [0];
  const startDate = "";

  return (
    <CaseList
      Type={"Edit"}
      startdate={startDate}
      enddate={date}
      casestatusParam={casestatus}
      pageName={"Pending Case List"}
    />
  );
};

export default EditCaseListPage;
